import styled from 'styled-components';
import { PMTAdsense } from '../PMTAdsense';

export const CustomAdsense = styled(PMTAdsense)(({ theme }) => ({
  padding: `${theme.spacing[16]} 37px`,

  [`${theme.mediaBreakpointUp.md}`]: {
    padding: `${theme.spacing[16]} 26px`,
  },
}));
